import { Box } from "@mui/material";
import React from "react";
import { CreateQuotationListContext } from "../../../contexts/createQuotationContext";
import { LeaseQuotationForm, SaleQuotationForm, ShortTermQuotationForm } from "../component";
export const QuotationDetailesNew = () => {
    const { dataNew, updateStateNew, setDataNew, setSelectedAccount, selectedAccount, t, setOpperEdit } = React.useContext(CreateQuotationListContext);
    return (
        <Box>
            {
                (dataNew?.searchdata?.revenue_type === "Lease" || dataNew?.searchdata?.revenue_type === "Manage") &&
                <LeaseQuotationForm
                    data={dataNew}
                    setData={setDataNew}
                    updateState={updateStateNew}
                    setSelectedAccount={setSelectedAccount}
                    selectedAccount={selectedAccount}
                    t={t}
                    opperEdit={false}
                    setOpperEdit={setOpperEdit}

                />
            }
            {
                dataNew?.searchdata?.revenue_type === "Sale" &&
                <SaleQuotationForm
                    data={dataNew}
                    setData={setDataNew}
                    updateState={updateStateNew}
                    setSelectedAccount={setSelectedAccount}
                    selectedAccount={selectedAccount}
                    t={t}
                    opperEdit={false}
                    setOpperEdit={setOpperEdit}


                />

            }
            {
                dataNew?.searchdata?.property_purpose === "Short Term Rental" &&
                <ShortTermQuotationForm
                    data={dataNew}
                    setData={setDataNew}
                    updateState={updateStateNew}
                    setSelectedAccount={setSelectedAccount}
                    selectedAccount={selectedAccount}
                    t={t}
                    opperEdit={false}
                    setOpperEdit={setOpperEdit}

                />
            }
        </Box>
    )
}